define("CCAW.CurrentYear.EntryPoint", [
    "CCAW.CurrentYear.View",
], function (CCAWCurrentYearView) {
    "use strict";

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent("Layout");

            if (!layout) {
                return;
            }

            layout.addChildView("CCAW.CurrentYear", function () {
                return new CCAWCurrentYearView({ container: container });
            });
        },
    };
});
